import {
    connect
} from 'react-redux'
import Fitting1AppCheckComponent from '../components/Fitting1AppCheckComponent.jsx';
import {
    changeOrderAppCheckValue,
    editOrderAppCheck,
    addOrderAppCheck,
    changeShowAppCheckDiv,
    clearOrderAppCheckData
} from '../actions';

const mapStateToProps = (state) => ({
    orderId: state.getIn(['fitting1Reducer', 'orderId']),
    orderAppCheck: state.getIn(['fitting1Reducer', 'orderAppCheck']),
    orderAppCheckValidation: state.getIn(['fitting1Reducer', 'orderAppCheckValidation']),
    showAppCheckDiv: state.getIn(['fitting1Reducer', 'showAppCheckDiv']),
    alertStyle: state.getIn(['fitting1Reducer', 'alertStyle']),
    alertMessage: state.getIn(['fitting1Reducer', 'alertMessage']),
})

const mapDispatchToProps = (dispatch) => ({
    setValue: (id, value) => {
        dispatch(changeOrderAppCheckValue({
            id: id,
            value: value
        }))
    },
    editAppCheck: (orderAppCheck) => {
        dispatch(editOrderAppCheck(orderAppCheck));
    },
    addAppCheck: (orderAppCheck) => {
        dispatch(addOrderAppCheck(orderAppCheck));
    },
    changeShowAppCheckDiv: (showAppCheckDiv) => {
        dispatch(changeShowAppCheckDiv(showAppCheckDiv));
    },
    showOrderAddAppCheck: (orderId) => {
        dispatch(clearOrderAppCheckData(orderId));
        dispatch(changeShowAppCheckDiv('add'));
    }
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    orderId: stateProps.orderId,
    orderAppCheck: stateProps.orderAppCheck,
    orderAppCheckValidation: stateProps.orderAppCheckValidation,
    showAppCheckDiv: stateProps.showAppCheckDiv,
    alertStyle: stateProps.alertStyle,
    alertMessage: stateProps.alertMessage,
    setValue: dispatchProps.setValue,
    editAppCheck: () => dispatchProps.editAppCheck(stateProps.orderAppCheck),
    addAppCheck: () => dispatchProps.addAppCheck(stateProps.orderAppCheck),
    changeShowAppCheckDiv: () => dispatchProps.changeShowAppCheckDiv(stateProps.showAppCheckDiv),
    showOrderAddAppCheck: () => dispatchProps.showOrderAddAppCheck(stateProps.orderId)
})

const Fitting1AppCheckContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Fitting1AppCheckComponent)

export default Fitting1AppCheckContainer;


// WEBPACK FOOTER //
// ./src/containers/Fitting1AppCheckContainer.jsx